import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/useStyles.js